var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicThin = function SvgMicThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1 5.5a3.9 3.9 0 1 1 7.8 0v6a3.9 3.9 0 0 1-7.8 0v-6ZM12 2.4a3.1 3.1 0 0 0-3.1 3.1v6a3.1 3.1 0 1 0 6.2 0v-6A3.1 3.1 0 0 0 12 2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4 9.6c.22 0 .4.18.4.4v1.5a6.2 6.2 0 0 0 12.4 0V10a.4.4 0 0 1 .8 0v1.5a7 7 0 1 1-14 0V10c0-.22.18-.4.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6c.22 0 .4.18.4.4v2a.4.4 0 0 1-.8 0v-2c0-.22.179-.4.4-.4Z"
  }))));
};
export default SvgMicThin;